<template>
  <div class="px-2">
    <MenuEntry v-for="entry in menuEntries" :key="entry.id" :entry="entry" />
    <MenuEntry v-if="isAdminAndIpadOrWeb" :entry="adminEntry" />
  </div>
</template>

<script>
import MenuEntry from './MenuEntry';
import MENU from '@/config/navigation/main-sidebar-menu';
import PlatformMixin from '../../mixins/PlatformMixin';
import { mapGetters } from 'vuex';
import StoreModules from '../../store/store-modules';
export default {
  name: 'MenuEntries',
  components: { MenuEntry },
  mixins: [PlatformMixin],
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {
      MENU,
      adminEntry: {
        id: 'admin',
        icon: 'el-icon-s-help',
        translationKey: 'general.admin',
        routeName: 'AdminDashboardPageRoute',
        subItems: [],
        hideOnDesktop: false,
      },
    };
  },
  computed: {
    ...mapGetters(StoreModules.USER, ['isAdmin']),
    menuEntries() {
      return MENU.filter((el) => {
        return !(!this.isMobile && el.hideOnDesktop);
      });
    },
    isAdminAndIpadOrWeb() {
      return this.isAdmin && (this.model === 'iPad' || this.plattform === 'web');
    },
  },
  methods: {},
};
</script>
